import { useMutation, useQueryClient } from '@tanstack/react-query';

import { storesApi } from '../api/stores-api';

import { storeKeys } from './store-keys';

/** The key lands in `settings.seo.indexNowKey`, so the store detail is refetched. */
export function useRotateIndexNowKey(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => storesApi.rotateIndexNowKey(storeId),
    meta: { successMessage: 'stores:indexNow.rotated' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: storeKeys.detail(storeId) }),
  });
}
